import { http } from '@/services/http.js'

export async function pollForUpdate(item, duration = 5000, max = 30000, start = Date.now()) {
  await delay(duration)
  const response = await http.get(`/api/images/${item.id}/`)
  const d = response.data
  if ((d.updated !== item.updated) && d.preview) {
    return response
  } else if (Date.now() - start < max - duration) {
    return pollForUpdate(item, duration, max, start)
  } else {
    throw new Error('Polling reached time limit')
  }
}

function delay(duration) {
  return new Promise(resolve => setTimeout(resolve, duration))
}
